<template>
  <v-autocomplete
    v-model="select"
    :loading="isLoading"
    :items="products"
    :search-input.sync="search"
    :item-text="createSelectLabel"
    :item-value="returnData"
    color="secondary"
    label="Search for products:"
    :return-object="false"
    solo
    hide-details
    light
    hide-no-data
    prepend-inner-icon="search"
    cache-items
  ></v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ProductSearch",
  props: {
    index: Number
  },

  data() {
    return {
      select: null,
      search: null,
      timeout: null
    };
  },

  computed: {
    ...mapGetters({
      isLoading: "app/isLoading",
      products: "product/getProduct"
    })
  },

  methods: {
    ...mapActions({
      productSearch: "product/search"
    }),

    createSelectLabel(e) {
      let label = e.display_name;
      return label;
    },

    returnData(e) {
      return e;
    }
  },

  watch: {
    select(product) {
      product.index = this.index || 0;
      this.$emit("product-selected", product);
    },

    search(value) {
      clearTimeout(this.timeout);
      if (value && value !== "" && value.length > 2) {
        let self = this;
        self.timeout = setTimeout(() => {
          self.productSearch({
            body: {
              kwargs: {
                product: value,
                id: false
              }
            }
          });
        }, 1000);
      }
    }
  }
};
</script>
